import React from "react";
import { useSelector } from "react-redux";
import { adjustHexColor as hexToHLS } from "../../../utils/functions/hexToHLS"


const CustomUserIcon = ({ className }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const colorSecondary = useSelector((state) => state.app.secondaryColor);
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 68 68"
    >
      <g>
        <path d="M66.99,34c0,9.27-3.83,17.65-9.99,23.64-5.95,5.79-14.06,9.35-23,9.35s-17.07-3.56-23.01-9.34c-6.15-6-9.98-14.38-9.98-23.65C1.01,15.78,15.78,1.01,34,1.01s32.99,14.77,32.99,32.99Z" fill={colorSecondary} strokeWidth="0px" />
        <path d="M34,1.01c18.22,0,32.99,14.77,32.99,32.99,0,9.27-3.83,17.65-9.99,23.64-5.95,5.79-14.06,9.35-23,9.35s-17.07-3.56-23.01-9.34c-6.15-6-9.98-14.38-9.98-23.65C1.01,15.78,15.78,1.01,34,1.01M34,0C15.25,0,0,15.25,0,34c0,9.25,3.65,17.91,10.28,24.37,6.39,6.21,14.81,9.63,23.72,9.63s17.32-3.42,23.71-9.64c6.64-6.45,10.29-15.1,10.29-24.36C68,15.25,52.75,0,34,0h0Z" fill=" #000" strokeWidth="0px" />
      </g>
      <g>
        <path d="M8.09,54.43l2.1,2.61s8.58-11.35,23.81-11.74,22.21,10.75,22.21,10.75c0,0-7.07-12.03-19.29-12.96s-18.35.32-28.84,11.33Z" fill={hexToHLS(colorSecondary)} strokeWidth="0px" />
        <path d="M42.32,18.61s-6.14-7.7-16.28-3.38c-11.68,4.98-8.89,19.87-3.47,23.69s15.2-4.92,15.2-4.92l4.56-15.39Z" fill={hexToHLS(colorSecondary)} strokeWidth="0px" />
        <g>
          <circle cx="34" cy="30" r="13.1" fill={colorPrimary} strokeWidth="0px" />
          <path d="M34,16.9c7.23,0,13.1,5.87,13.1,13.1s-5.87,13.1-13.1,13.1-13.1-5.87-13.1-13.1,5.87-13.1,13.1-13.1M34,15.89c-7.78,0-14.11,6.33-14.11,14.11s6.33,14.11,14.11,14.11,14.11-6.33,14.11-14.11-6.33-14.11-14.11-14.11h0Z" fill=" #000" strokeWidth="0px" />
        </g>
        <g>
          <path d="M57,57.64c-5.95,5.79-14.06,9.35-23,9.35s-17.07-3.56-23.01-9.34c5.3-6.9,13.64-11.35,23.01-11.35s17.71,4.44,23,11.34Z" fill={colorPrimary} strokeWidth="0px" />
          <path d="M34,46.3c9.38,0,17.71,4.44,23,11.34-5.95,5.79-14.06,9.35-23,9.35s-17.07-3.56-23.01-9.34c5.3-6.9,13.64-11.35,23.01-11.35M34,45.3c-9.4,0-18.08,4.28-23.81,11.74l-.55.71.64.62c6.39,6.21,14.81,9.63,23.71,9.63s17.32-3.42,23.71-9.64l.64-.62-.54-.71c-5.72-7.46-14.4-11.73-23.8-11.73h0Z" fill=" #000" strokeWidth="0px" />
        </g>
      </g>
    </svg>
  );
};

export default CustomUserIcon;
